import { fromJS, Map } from 'immutable';
import { SET_PROJECT, SET_PROJECT_UNDOABLE } from './project';
import { SET_BACKGROUND_IMAGE } from './backgrounds';
import { renderCanvasFromStore } from './navigation';
import { REPLACE_PAGE } from './pages';
import { v4 as uuidv4 } from 'uuid';
import { hexToDecimal } from '../utils/color';
import { takeEvery, put, select } from 'redux-saga/effects';
import * as Selectors from '../reducers/selectors';
import SpineHelper from '../helpers/SpineHelper';
import PicabooConstants from '../common/PicabooConstants';
const { ITEM_TYPES, WELL_TYPES } = PicabooConstants;

/**
 *  action constants
 */
export const PAGE_ITEMS_UPDATED = 'pageItems/PAGE_ITEMS_UPDATED';
export const UPDATE_PAGE_ITEMS = 'pageItems/UPDATE_PAGE_ITEMS';
export const UPDATE_PAGE_ITEMS_BY_OTHER =
  'pageItems/UPDATE_PAGE_ITEMS_BY_OTHER';
export const UPDATE_PAGE_ITEMS_NO_UNDO = 'pageItems/UPDATE_PAGE_ITEMS_NO_UNDO';
export const UPDATE_PAGE_ITEMS_SPELLCHECK =
  'pageItems/UPDATE_PAGE_ITEMS_SPELLCHECK';
export const UPDATE_PAGE_ITEMS_LOWRES = 'pageItems/UPDATE_PAGE_ITEMS_LOWRES';
export const ADD_LINE_PAGE_ITEM = 'pageItems/ADD_LINE_ITEMS';
export const INSERT_PAGE_ITEMS = 'pageItems/INSERT_PAGE_ITEMS';
export const ADD_PAGE_ITEMS = 'pageItems/ADD_PAGE_ITEMS';
export const ADD_PAGE_ITEMS_BY_OTHER = 'pageItems/ADD_PAGE_ITEMS_BY_OTHER';
export const REMOVE_PAGE_ITEMS = 'pageItems/REMOVE_PAGE_ITEMS';
export const REMOVE_PAGE_ITEMS_NO_UNDO = 'pageItems/REMOVE_PAGE_ITEMS_NO_UNDO';
export const REMOVE_PAGE_ITEMS_BY_OTHER =
  'pageItems/REMOVE_PAGE_ITEMS_BY_OTHER';

/**
 *  reducers
 */
function pageItems(state = new Map(), action) {
  // let newState = state;// {...state}; immutable now so we can just assign it the old state
  switch (action.type) {
    case SET_PROJECT_UNDOABLE:
    case SET_PROJECT:
      return action.project.pageItems != undefined
        ? fromJS(
            action.project.pageItems.length == 0
              ? {}
              : action.project.pageItems,
          )
        : state;
    case UPDATE_PAGE_ITEMS_SPELLCHECK:
    case UPDATE_PAGE_ITEMS_LOWRES:
    case UPDATE_PAGE_ITEMS_NO_UNDO:
    case UPDATE_PAGE_ITEMS:
      // let updatedItems = [];
      let newState = state;
      action.pageItems.map((pageItem) => {
        newState = newState.set(pageItem.get('id'), pageItem);
      });
      return newState;

    case REPLACE_PAGE:
      // let updatedItems = [];
      let replaceState = new Map();
      action.pageItems.map((pageItem) => {
        replaceState = replaceState.set(pageItem.get('id'), pageItem);
      });
      return replaceState;

    case SET_BACKGROUND_IMAGE:
      //let selectedImagePageItem = new BackgroundImageToPageItemAdapter(action.image);
      // newState = state.set(action.imageID.toUpperCase(), new Map(action.pageItem));
      newState = state.set(action.pageItem.id, new Map(action.pageItem));
      if (action.otherItem) {
        newState = newState.set(action.otherItem.get('id'), action.otherItem);
      }
      return newState;
    case ADD_LINE_PAGE_ITEM:
      return state.set(action.lineItem.get('id'), action.lineItem);
    case INSERT_PAGE_ITEMS:
      newState = state;
      action.pageItems.forEach(function (pi) {
        newState = newState.set(pi.get('id'), pi);
      });
      return newState;
    case ADD_PAGE_ITEMS:
    case ADD_PAGE_ITEMS_BY_OTHER:
      // return state.set(action.item.get('id'), action.item );

      newState = state;
      action.pageItems.forEach((pi) => {
        newState = newState.set(pi.get('id'), pi);
      });
      return newState;
    case REMOVE_PAGE_ITEMS_NO_UNDO:
    case REMOVE_PAGE_ITEMS:
      // return state.delete(action.item);
      newState = state;
      action.items.forEach((itemID) => {
        newState = newState.delete(itemID);
      });
      return newState;
  }

  return state;
}

/**
 *  actions
 */
export function updatePageItems(pageItems, sendChangeset = true) {
  return {
    type: UPDATE_PAGE_ITEMS,
    pageItems,
    sendChangeset,
  };
}

export function updatePageItemsNoUndo(pageItems, sendChangeset = false) {
  return {
    type: UPDATE_PAGE_ITEMS_NO_UNDO,
    pageItems,
    sendChangeset,
  };
}

export function updatePageItemsSpellcheck(pageItems) {
  return {
    type: UPDATE_PAGE_ITEMS_SPELLCHECK,
    pageItems,
  };
}

export function updatePageItemsLowres(pageItems) {
  return {
    type: UPDATE_PAGE_ITEMS_LOWRES,
    pageItems,
  };
}

export function updatePageItemsByOther(pageItems) {
  return {
    type: UPDATE_PAGE_ITEMS_BY_OTHER,
    pageItems,
  };
}

export function insertPageItems(pageItems) {
  return {
    type: INSERT_PAGE_ITEMS,
    pageItems,
  };
}

export function addPageItems(page, pageItems) {
  if (!Array.isArray(pageItems)) pageItems = Array.of(pageItems);

  return {
    type: ADD_PAGE_ITEMS,
    pageItems,
    page,
  };
}

export function removePageItems(page, items) {
  if (!Array.isArray(items)) items = Array.of(items);

  return {
    type: REMOVE_PAGE_ITEMS,
    items,
    page,
  };
}

export function removePageItemsNoUndo(page, items) {
  if (!Array.isArray(items)) items = Array.of(items);

  return {
    type: REMOVE_PAGE_ITEMS_NO_UNDO,
    items,
    page,
  };
}

export function removePageItemsByOther(page, items) {
  return {
    type: REMOVE_PAGE_ITEMS_BY_OTHER,
    items,
    page,
  };
}

/**
 * Sagas
 */

function* updatePageItemsSaga(action) {
  let pageID = action.pageItems[0].get('pageID');
  let pages = yield select(Selectors.pagesSelector);
  if (pages.get(pageID) !== undefined) {
    yield put(updatePageItemsNoUndo(action.pageItems));
    yield put(renderCanvasFromStore(pageID));
  }
}

function* removePageItemsSaga(action) {
  let pages = yield select(Selectors.pagesSelector);
  if (pages.get(action.page) !== undefined) {
    yield put(removePageItemsNoUndo(action.page, action.items));
    yield put(renderCanvasFromStore(action.page));
  }
}

function* adjustDynamicPageDataAdapter(action) {
  return action.type === INSERT_PAGE_ITEMS
    ? {
        pageItems: action.pageItems.map((p) => p.toJS()),
        project: (yield select(Selectors.projectMetadataSelector)).toJS(),
        page: Object.values((yield select(Selectors.pagesSelector)).toJS())[0],
        productInfo: yield select(Selectors.productInfo),
      }
    : {
        pageItems: action.project.pageItems,
        project: action.project.project,
        page: Object.values(action.project.pages)[0],
        productInfo: fromJS(action.project.productInfo),
      };
}

function* adjustDynamicPageItems(action) {
  try {
    let data = yield adjustDynamicPageDataAdapter(action);
    let pageItems = data.pageItems;
    if (pageItems) {
      for (const pageItem of Object.values(pageItems)) {
        if (pageItem.dynamicSizePosition) {
          let project = data.project;
          let numberPages = project.numPages;

          if (pageItem.dynamicSizeForPages !== numberPages) {
            let page = data.page;
            let w = page.ratioBase;

            let subType = project.subtype;
            let style = project.style;
            const spineWidth = SpineHelper.calculateSpineWidth(
              w,
              numberPages,
              subType,
              style,
              data.productInfo,
            );
            if (pageItem.right === 'left_spine') {
              pageItem.positionX = 0;
              pageItem.width = w / 2 - spineWidth / 2 + 0.001;
            }

            if (pageItem.left === 'left_spine') {
              pageItem.positionX = w / 2 - spineWidth / 2;
              pageItem.width = w / 2 + spineWidth;
            }

            pageItem.height = page.ratio;
            pageItem.dynamicSizeForPages = numberPages;

            yield put(updatePageItems([fromJS(pageItem)]));
            yield put(renderCanvasFromStore(page.id));
          }
        }
      }
    }
  } catch (e) {
    console.error('failed to adjust page items', e);
  }
}

function* setupSagas() {
  yield takeEvery(UPDATE_PAGE_ITEMS_BY_OTHER, updatePageItemsSaga);
  yield takeEvery(REMOVE_PAGE_ITEMS_BY_OTHER, removePageItemsSaga);
  yield takeEvery(
    [SET_PROJECT, SET_PROJECT_UNDOABLE, INSERT_PAGE_ITEMS],
    adjustDynamicPageItems,
  );
}

/**
 * Utils
 */
export function createLineItem(pageId, pageX = 0.3, pageY = 0.25) {
  const lineHeight = 0.01;
  const lineWidth = 0.3;
  const cordX = pageX; // - (lineWidth/2);
  const cordY = pageY; // - (lineHeight/2);
  return fromJS({
    itemType: ITEM_TYPES.LINE,
    id: uuidv4().toUpperCase(),
    positionX: cordX,
    positionY: cordY,
    width: lineWidth,
    height: lineHeight,
    rotation: 0,
    thickness: 4,
    color: 0,
    pattern: 'solid',
    caps: 'square',
    pageID: pageId,
  });
}

export function createTextItem(pageId, pageX = 0.33, pageY = 0.33) {
  const textWidth = 0.5;
  const textHeight = 0.01;
  const cordX = pageX; // - (textWidth/2);
  const cordY = pageY; // - (textHeight/2);
  return fromJS({
    id: uuidv4().toUpperCase(),
    backgroundColor: 'rgba(255,255,255,1)',
    showBackground: false,
    fill: 'rgb(0,0,0)',
    fontAlignment: 'null',
    fontFamily: 'Archivo',
    fontSize: 24,
    height: textHeight,
    image_height: null,
    image_positionX: null,
    image_positionY: null,
    image_width: null,
    itemType: ITEM_TYPES.CAPTION,
    maxChars: 0,
    positionX: cordX,
    positionY: cordY,
    rotation: 0,
    elements: [
      {
        text: '',
        font: 'Archivo',
        size: '24',
      },
    ],

    text: '',
    textAlign: 'left',
    type: 'N',
    verticalAlign: 'top',
    width: textWidth,
    pageID: pageId,
  });
}

export function createRichTextItem(
  pageId,
  pageX = 0.33,
  pageY = 0.33,
  settings = null,
) {
  const textWidth = 0.257729591836735;
  const textHeight = 0.17295918367347;
  const cordX = pageX; // - (textWidth/2);
  const cordY = pageY; // - (textHeight/2);
  return fromJS({
    id: uuidv4().toUpperCase(),
    backgroundColor: 'rgba(255,255,255,0)',
    showBackground: false,
    fill:
      settings && settings.get('fontColor')
        ? settings.get('fontColor')
        : 'rgb(0,0,0)',
    fontAlignment: 'null',
    fontFamily:
      settings && settings.has('fontFamily')
        ? settings.get('fontFamily')
        : process.env.defaultFontFamily,
    fontSize:
      settings && settings.has('fontSize') ? settings.get('fontSize') : 16,
    height: textHeight,
    image_height: null,
    image_positionX: null,
    image_positionY: null,
    image_width: null,
    itemType: ITEM_TYPES.RICH_TEXT,
    maxChars: 0,
    positionX: cordX,
    positionY: cordY,
    rotation: 0,
    styles: {},
    text: '',
    textAlign: 'left',
    type: 'N',
    verticalAlign: 'top',
    width: textWidth,
    pageID: pageId,
  });
}

export function createEngravingItem(pageId, line1, line2) {
  return fromJS({
    id: uuidv4().toUpperCase(),

    itemType: ITEM_TYPES.ENGRAVING,
    line1: line1,
    line2: line2,
    pageID: pageId,
  });
}

export function createShapeItem(
  pageId,
  shapeName = 'rect',
  pageX = 0.33,
  pageY = 0.33,
) {
  let shapeWidth = 0.3;
  let shapeHeight = 0.2;
  let cordX = pageX; // - (shapeWidth/2);
  let cordY = pageY; // - (shapeHeight/2);

  switch (shapeName) {
    case 'circle':
      shapeHeight = shapeWidth;
      break;
    case 'oval':
      shapeHeight = shapeWidth / 2;
      break;
    case 'square':
      shapeHeight = shapeWidth;
      break;
  }

  let shape = fromJS({
    id: uuidv4().toUpperCase(),
    pageID: pageId,
    fillColor: hexToDecimal('#CCCCCC'),
    shadowEnabled: false,
    image_width: 0,
    width: shapeWidth,
    height: shapeHeight,
    image_height: 0,
    image_positionX: 0,
    image_positionY: 0,
    itemType: ITEM_TYPES.SHAPE,
    borderSize: 8 / 12.0,
    positionX: cordX,
    positionY: cordY,
    borderEnabled: true,
    borderColor: 0,
    shapeType: shapeName,
    fillEnabled: true,
    alpha: 1,
    rotation: 0,
  });

  return shape;
}

export function createGraphicItem(
  pageId,
  imageID,
  width,
  height,
  imageType,
  posX,
  posY,
) {
  let gi = fromJS({
    itemType: ITEM_TYPES.GRAPHICITEM,
    id: uuidv4().toUpperCase(),
    type: WELL_TYPES.NORMAL,
    imageID: imageID,
    positionX: posX,
    positionY: posY,
    width: width,
    height: height,
    rotation: 0,
    image_positionX: 0,
    image_positionY: 0,
    image_width: width,
    image_height: height,
    image_rotation: 0,
    image_orientation: 0,
    linkedGraphicItemID: '',
    pageID: pageId,
    maskShape: '',
    filters: [
      {
        name: 'Border',
        value: '0|.66',
        enabled: false,
      },
    ],
  });

  return gi;
}

export function createNamesItem(
  pageId,
  pageX = 0.33,
  pageY = 0.33,
  width = 0.3,
  height = 0.1,
) {
  const cordX = pageX; // - (textWidth/2);
  const cordY = pageY; // - (textHeight/2);
  return fromJS({
    id: uuidv4().toUpperCase(),
    font: 'Arial',
    fontColor: '#000000',
    fontSize: 10,
    height: height,
    image_height: 0,
    image_positionX: 0,
    image_positionY: 0,
    image_width: 0,
    includeCustomInfo: false,
    itemType: 'names',
    pageID: pageId,
    portraitNames: [],
    portraits: [],
    positionX: cordX,
    positionY: cordY,
    rotation: NaN,
    textAlign: 'right',
    type: 'N',
    width: width,
  });
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: pageItems,
  saga: setupSagas,
};
